import React from 'react';
import PageTitle from 'components/PageTitle';
import SearchCriteria from 'components/SearchCriteria';

const InsurerPremiumByCountyPage = () => {
  return (
    <>
      <PageTitle>Insurer Premium By County</PageTitle>
      <SearchCriteria />
    </>
  );
};

export default InsurerPremiumByCountyPage;
